/** @jsx jsx */

import { Fragment } from 'react';
import { find, includes } from 'lodash';

import { jsx } from '@emotion/core';

import { GuideStepItem } from 'app/cli-guide/types';

import GuideSidebarItem from '../GuideSidebarItem';

type StepList = Array<GuideStepItem>;
type StepKeys = Array<string>;
type Props = {
  currentStep: string;
  disabledSteps?: StepKeys;
  onSelectStep: (step?: GuideStepItem) => void;
  steps: StepList;
  stepsSeen: StepKeys;
};

const Items = (props: Props) => {
  const { currentStep, disabledSteps, stepsSeen, onSelectStep, steps } = props;

  const currentStepFromKey = find(steps, step => step.key === currentStep) || {
    parentKey: undefined,
  };

  return (
    <Fragment>
      {steps.map(step => {
        const isCompleted = includes(stepsSeen, step.key);
        const isDisabled = includes(disabledSteps, step.key);
        const isActive = currentStep === step.key;

        const isTopLevel = !step.parentKey;
        const isSiblingOfCurrentStep =
          currentStepFromKey.parentKey &&
          step.parentKey === currentStepFromKey.parentKey;
        const isParentOfCurrentStep = step.key === currentStepFromKey.parentKey;
        const isChildOfCurrentStep =
          step.parentKey && step.parentKey === currentStep;

        const sidebarItemProps = {
          key: step.key,
          step,
          isActive,
          isCompleted,
          isDisabled,
          onSelectStep: () => onSelectStep(step),
        };

        if (isSiblingOfCurrentStep) {
          return <GuideSidebarItem {...sidebarItemProps} isSubStep={true} />;
        } else if (isParentOfCurrentStep) {
          return <GuideSidebarItem {...sidebarItemProps} isActive={true} />;
        } else if (isChildOfCurrentStep) {
          return <GuideSidebarItem {...sidebarItemProps} isSubStep={true} />;
        } else if (isTopLevel) {
          return <GuideSidebarItem {...sidebarItemProps} />;
        }
        return null; // This means it is a sub-item but not a sibling of the active step.
      })}
    </Fragment>
  );
};

export default Items;
